<template>
  <v-card class="card-curvey">
    <v-layout row wrap>
      <v-flex xs4 style="margin-top: 30px !important; padding-left: 0">
        <v-text-field
          v-model="queries.q"
          placeholder="Search.."
          entityend-icon="search"
          outline
          @input="getUnknownTerms"
        />
      </v-flex>
      <v-spacer />
      <v-btn
        color="blue-grey"
        class="nlp-nav-btn"
        style="margin-top: 30px"
        :href="exportUrl"
        target="_blank"
        small
        outline
      >
        <v-icon>launch</v-icon>
        Export
      </v-btn>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="unknownTerms"
      :loading="loaders.unknownTerms"
      disable-pagination
      hide-actions
      class="elevation-1 nlp-data-table"
    >
      <template v-slot:items="props">
        <td style="max-width: 180px; word-break: break-word">
          {{ props.item.utterance }}
        </td>
        <td class="justify-center">
          <v-select
            v-model="unknownTerms[props.index].appModel"
            :items="apps"
            item-text="name"
            item-value="id"
            outline
            dense
            hide-details
            class="unknow-terms-field-height"
            style="width: 180px; display: inline-block"
            @input="getIntents($event, props.index)"
          >
            <template v-slot:selection="{ item }">
              <span>{{ item.name.slice(0, 20) }}</span>
            </template>
          </v-select>
        </td>
        <td class="justify-center">
          <v-select
            v-model="unknownTerms[props.index].intentModel"
            :items="intents[props.index]"
            :loading="unknownTerms[props.index].intentLoading"
            item-text="name"
            item-value="id"
            outline
            dense
            hide-details
            style="width: 150px; display: inline-block"
          >
            <template v-slot:selection="{ item }">
              <span>{{ item.name.slice(0, 20) }}</span>
            </template>
          </v-select>
          <v-btn
            :loading="unknownTerms[props.index].loading"
            color="success"
            class="unknwon-terms-accept-btn"
            @click="acceptTerm(props)"
          >
            <v-icon> check </v-icon>
          </v-btn>
        </td>
        <td style="max-width: 120px; word-break: break-word">
          <span v-if="props.item.score">
            {{ props.item.score }}
          </span>
        </td>
        <td class="justify-center layout px-0">
          <v-btn
            :loading="unknownTerms[props.index].deleteLoader"
            small
            round
            fab
            class="mr-2 white--text"
            color="red"
            @click="deleteUnknownTerm(props)"
          >
            <v-icon>delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
    <v-divider />
    <v-layout row wrap>
      <v-flex xs10>
        <v-layout justify-center align-content-center style="padding-top: 15px">
          <v-pagination
            slot="footer"
            v-model="pagination.page"
            :length="paginationCount"
            style="width: auto !important; margin: auto !important"
            @input="getUnknownTerms"
          />
        </v-layout>
      </v-flex>
      <v-flex xs2 align-self-center>
        <v-spacer />
        <div style="text-align: right"><small>Items Per Page</small></div>
        <v-select
          v-model="pagination.per_page"
          :items="[5, 10, 15, 20, 25]"
          style="width: 70px; float: right"
          outline
          @input="getUnknownTerms"
        />
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import env from "../../utils/env";
const nlpBaseUrl = env.NLP_BASE_URL;

export default {
  name: "unknown-words",
  data() {
    return {
      unknownTerms: [],
      queries: {
        q: "",
      },
      pagination: {
        page: 1,
        per_page: 15,
      },
      loaders: {
        unknownTerms: true,
      },
      paginationCount: 0,
      intents: [],
      appsIntents: {},
      headers: [
        {
          text: "Utterance",
          align: "left",
          sortable: false,
          value: "keyword",
        },
        {
          text: "App",
          // align: 'center',
          sortable: false,
          value: "times",
        },
        {
          text: "Accept",
          // align: 'center',
          sortable: false,
          value: "times",
        },
        {
          text: "Score",
          // align: 'center',
          sortable: false,
          value: "times",
        },
        {
          text: "Delete",
          align: "center",
          sortable: false,
          value: "train",
        },

        // { text: 'Actions', value: 'name', sortable: false, align: 'center', }
      ],
    };
  },
  async mounted() {
    await this.getApps();
    await this.getUnknownTerms();
  },
  computed: {
    apps() {
      return this.$store.state.nlp.apps;
    },
    selectedApp() {
      return this.$store.state.nlp.selectedApp;
    },
    botId() {
      return this.$store.state.bot.botId;
    },
    exportUrl() {
      return `${nlpBaseUrl}/bots/${this.botId}/unknown-terms/export`;
    },
  },
  methods: {
    async getApps() {
      await this.$store.dispatch("nlp/apps/get", null).then(() => {
        this.intents = this.unknownTerms.map(() => []);
      });
    },
    async getIntents(app, index) {
      if (this.appsIntents[app]) {
        this.intents[index] = this.$_.cloneDeep(this.appsIntents[app]);
        return;
      }
      try {
        this.unknownTerms[index].intentLoading = true;
        const res = await this.$http_nlp.get(`/apps/${app}/intents`);
        this.intents[index] = this.$_.cloneDeep(res.data.data.result);
        this.appsIntents[app] = this.$_.cloneDeep(res.data.data.result);
        this.unknownTerms[index].intentLoading = false;
      } catch (err) {
        this.unknownTerms[index].intentLoading = false;
      }
    },
    async getUnknownTerms() {
      let params = { ...this.pagination };
      if (this.queries.q && this.queries.q.length)
        params["filter[utterance]"] = this.queries.q;
      // this.$store.dispatch('setLoader',true)
      this.loaders.unknownTerms = true;
      const response = await this.$http_nlp({
        url: `/bots/${this.botId}/unknown-terms`,
        method: "get",
        params,
      });

      this.unknownTerms = [];
      this.paginationCount = Math.ceil(
        response.data.data.count / this.pagination.per_page
      );
      this.unknownTerms = response.data.data.result.map((i) => ({
        ...i,
        deleteLoader: false,
        loading: false,
        intentLoading: false,
        intentModel: i.intent ? i.intent.id : null,
        appModel: i.app.id ? i.app.id : null,
      }));
      this.intents = this.unknownTerms.map(() => []);
      // this.$store.dispatch('setLoader',false)
      this.unknownTerms.forEach(async (row, index) => {
        if (row.appModel) {
          await this.getIntents(row.appModel, index);
        }
      });
      this.loaders.unknownTerms = false;
    },
    async acceptTerm({ index, item }) {
      try {
        this.unknownTerms[index].loading = true;
        await this.$http_nlp.post(
          `/apps/${this.unknownTerms[index].appModel}/predictions/${item.id}/accept`,
          { intent: item.intentModel }
        );
        await this.getUnknownTerms();
        this.unknownTerms[index].loading = false;
        this.$store.dispatch("setSnackbar", {
          text: "Updated Successfully",
          color: "success",
        });
      } catch (e) {
        this.unknownTerms[index].loading = false;
        throw e;
      }
    },
    async deleteUnknownTerm({ item, index }) {
      this.unknownTerms[index].deleteLoader = true;
      await this.$http_nlp
        .delete(`/bots/${this.botId}/unknown-terms/${item.id}`)
        .then(() => {
          this.getUnknownTerms();
          this.unknownTerms[index].deleteLoader = false;
          this.$store.dispatch("setSnackbar", {
            text: "Deleted Successfully",
            color: "success",
          });
        });

      this.unknownTerms[index].deleteLoader = false;
    },
    async trainTerm(term) {
      await this.$http_bot.post(`analytics/`, {
        term: term,
      });

      let index = this.unknownTerms.findIndex((item) => {
        return term === item.keyword;
      });
      this.unknownTerms.splice(index, 1);
    },
  },
};
</script>
<style lang="scss" src="../../assets/sass/commponents/nlp.scss"></style>
<style>
.theme--light.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: transparent !important;
}
.unknow-terms-field-height {
  height: 35px;
}
.unknwon-terms-accept-btn {
  width: 50px !important;
  min-width: 50px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  margin-left: -5px;
  height: 35px;
}
</style>
